/**
 * Basic
 */
window.appName = process.env.MIX_APP_NAME;
window.ytv = process.env.MIX_REGISTER_VIDEO;

/**
 * Base url
 */

let baseUrl = document.head.querySelector('meta[name="base-url"]');

if (baseUrl) {
    window.baseUrl = baseUrl.content;
}

/**
 * Urls
 */

window.dcrm = process.env.MIX_DOMAIN_CRM;
window.dmembs = process.env.MIX_DOMAIN_MEMBERS;

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

const axios = require('axios');

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

axios.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        switch(error.response.status){
            case 423: // Locked
                window.location.href = "/user/confirm-password";
                break;
        }

        return Promise.reject(error);
    },
);

window.axios = axios;

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
